module.exports = __webpack_public_path__ + "static/media/Wallet.06707ca2.svg";